import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { environment } from '../../../environments/environment';

const http_options = {
	headers: new HttpHeaders({
		'Content-Type': 'multipart/form-data'
	})
};

@Injectable()
export class FreightMasterService {

	private url = environment.url
	constructor(private http: HttpClient) { }

	postFile(fileToUpload: FormData): Observable<boolean | {} > {
		const endpoint = this.url + '/upload/ratecard';
		// const formData: FormData = new FormData();
		// formData.append('rate_card_file', fileToUpload, fileToUpload.name);

		// console.log (fileToUpload.name);
		// console.log (formData);

		return this.http.post(endpoint, fileToUpload, http_options).map((res) => { console.log(res); return true; })
			// .catch((e) => this.handleError(e));
	}	

}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/_services/_masters/freight-master.service.ts